import React, { useState } from 'react';
import { MoreVertical, Check, XCircle } from 'lucide-react';
import ConversationMenu from './ConversationMenu';
import styles from './ConversationItem.scss';

const ConversationItem = ({
  conversation,
  isActive,
  onSelect,
  onUpdateTitle,
  onDelete,
  onExport,
  isExporting,
  isLightMode
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState('');
  const [showMenu, setShowMenu] = useState(false);

  const handleStartEdit = () => {
    setEditedTitle(conversation.title || conversation.preview || 'Untitled');
    setIsEditing(true);
    setShowMenu(false);
  };

  const handleSave = async () => {
    if (editedTitle.trim()) {
      await onUpdateTitle(conversation.conversation_id, editedTitle.trim());
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedTitle('');
  };

  const handleDelete = () => {
    setShowMenu(false);
    if (window.confirm('Delete this conversation?')) {
      onDelete(conversation.conversation_id);
    }
  };

  const handleExport = () => {
    setShowMenu(false);
    onExport(conversation.conversation_id);
  };

  return (
    <div 
      className={`${styles.conversationItem} ${isActive ? styles.activeConversation : ''} ${isLightMode ? styles.lightMode : ''}`}
      onClick={() => !isEditing && !showMenu && onSelect(conversation.conversation_id)}
    >
      <div className={styles.conversationMain}>
        {isEditing ? (
          <div className={styles.editTitleContainer} onClick={(e) => e.stopPropagation()}>
            <input
              type="text"
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSave();
                if (e.key === 'Escape') handleCancel();
              }}
              className={styles.editTitleInput}
              autoFocus
            />
            <div className={styles.editTitleActions}>
              <button
                className={styles.editTitleSave}
                onClick={handleSave}
                title="Save"
              >
                <Check size={12} />
              </button>
              <button
                className={styles.editTitleCancel}
                onClick={handleCancel}
                title="Cancel"
              >
                <XCircle size={12} />
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className={styles.conversationTitle}>
              {conversation.title || conversation.preview || 'Untitled'}
            </div>
            <div className={styles.conversationMeta}>
              <span>{conversation.message_count || 0} msgs</span>
              {isActive && <span className={styles.activeDot}>●</span>}
            </div>
          </>
        )}
      </div>

      {/* Actions menu */}
      {!isEditing && (
        <div className={styles.conversationActions}>
          <button
            className={styles.menuButton}
            onClick={(e) => {
              e.stopPropagation();
              setShowMenu(!showMenu);
            }}
            title="Actions"
          >
            <MoreVertical size={14} />
          </button>

          {showMenu && (
            <ConversationMenu
              onRename={handleStartEdit}
              onExport={handleExport}
              onDelete={handleDelete}
              onClose={() => setShowMenu(false)}
              isExporting={isExporting}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ConversationItem;

